import type { PropsWithChildren } from 'react';

type PaginationItemProps = PropsWithChildren<{
  isActive?: boolean;
  isDisabled?: boolean;
}>;

export const PaginationItem = ( { children, isActive, isDisabled }: PaginationItemProps ) => {

  return (
    <li
      data-active={ isActive }
      data-disabled={ isDisabled }
      className={ 'size-[34px] bg-[#17193F]/30 border border-white/20 hover:bg-[#17193F]/60 hover:border-white/20 data-[active=true]:border-white/60 data-[active=true]:bg-[#17193F] [&_i]:data-[disabled=true]:opacity-20 data-[disabled=true]:pointer-events-none text-white flex items-center justify-center text-inter text-sm rounded-lg' }>
      { children }
    </li>
  )
}
PaginationItem.displayName = 'PaginationItem';
